import { MkIcon } from "@/mk/MkIcon";
import type { ReactNode } from "react";

interface Props {
    icon?: string;
    title: string;
    description?: string;
    className?: string;
    children?: ReactNode;
}

export function MkEmptyState({ icon = "fa-inbox", title, description, className,
                               children }: Props) {
    return (
        <div className={`mk-empty mk-anim-rise${className ? ` ${className}` : ""}`}>
            <div className="mk-empty-icon"><MkIcon name={icon} /></div>
            <div className="mk-empty-title">{title}</div>
            {description && <div className="mk-empty-desc">{description}</div>}
            {children && <div className="mk-empty-action">{children}</div>}
        </div>
    );
}
